/**
 * Shared price formatting utility for billing & pricing UI.
 *
 * Uses Intl.NumberFormat for locale-aware currency display.
 * Default locale is 'de-DE' (German formatting: 12,50 €).
 */
export function formatPrice(
  amountCents: number,
  currency: string,
  locale = 'de-DE'
): string {
  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency.toUpperCase(),
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amountCents / 100);
  } catch {
    return `${(amountCents / 100).toFixed(2)} ${currency.toUpperCase()}`;
  }
}
